// actions.ts
import { Context, ISaveTechnicalReportPayload, ISaveFinalReportPayload, IActions } from './actions.types'
import { RootState } from '@/store/types'
import { ITechnicalReportData, Notification, INotification, TechnicalReport, ITechnicalReport } from '@/entities'
import { ActionTree } from 'vuex';
import { AppConstants as _app } from '@/shared/app.constants'


export const actions: IActions = {
   
    /** set the grant state on selection */
    getTechnicalReport(context: Context, id: number): any {
        if(id) {            
            return this.$services.monitor.getTechnicalReport(id)
            .then((data: any) => {
                context.commit('setTechnicalReport', { report: data });
                return data;
            });
        }
    },

    /** Start the technical Report */
    startTechnicalReport(context: Context, id: number): any {
        if(id) {            
            return this.$services.monitor.startTechnicalReport(id)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    return data;
                    // context.commit('application/setNotification', new Notification({ snack: true, text: 'Financial Report saved successfully', color: 'success' } as INotification),  { root: true });         
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
                }
            });
        }
    },
    /** update the technical report period */
    updateReportPeriod(context: Context, payload: ISaveTechnicalReportPayload): any {
        return this.$services.monitor.updateTechnicalReportPeriod(payload.id, payload.data)
            .then((resp: any) => {
                if (resp.Result === 'OK') {
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Technical Report saved successfully', color: 'success' } as INotification),  { root: true });         
                    return resp.Record;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: resp.Message, color: 'error' } as INotification),  { root: true })
                }
                
            });
    },
    /** save the grant header */
    saveTechnicalReport(context: Context, payload: ISaveTechnicalReportPayload): any {
        return this.$services.monitor.updateTechnicalReport(payload.id, payload.data)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    context.commit('setTechnicalReport', { report: data.Record });
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Technical Report saved successfully', color: 'success' } as INotification),  { root: true });         
                    return data;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
                }
                
            });
    },

    saveTechnicalReportData(context: Context, payload: any): any {
        return this.$services.monitor.saveTechnicalReport(payload.grantId, payload.reportId, payload.data)
        .then((data: any) => {
            if (data.Result === 'OK') {
                context.commit('setReportData', { report: data.Record });
                if(payload.context !== 'submit') {
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Technical Report saved successfully', color: 'success' } as INotification),  { root: true });         
                }
                return data;
            } else {
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
            }
        });
    },

    saveTechnicalReportDirty(context: Context, payload: any): any {
        context.commit('application/updateOverlay', true, { root: true });
        return this.$services.monitor.saveTechnicalReport(payload.grantId, payload.reportId, payload.data)
        .then((data: any) => {
            if (data.Result === 'OK') {
                context.commit('setReportData', { report: data.Record });
                if(payload.context !== 'submit') {
                    context.commit('application/updateOverlay', false, { root: true });
                    // context.commit('application/setNotification', new Notification({ snack: true, text: 'Technical Report saved successfully', color: 'success' } as INotification),  { root: true });         
                }
                return data;
            } else {
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
            }
        });
    },

    saveFinalReportDirty(context: Context, payload: ISaveFinalReportPayload): any {
        context.commit('application/updateOverlay', true, { root: true });
        return this.$services.monitor.saveFinalTechnicalReport(payload.grantId, payload.reportId, payload.data)
        .then((data: any) => {
            if (data.Result === 'OK') {
                context.commit('refreshModel', { report: data.Record });
                context.commit('application/updateOverlay', false, { root: true });
                // context.commit('application/setNotification', new Notification({ snack: true, text: 'Report saved successfully', color: 'success' } as INotification),  { root: true });         
            } else {
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
            }
        });
    },

    saveFinalReport(context: Context, payload: ISaveFinalReportPayload): any {
        return this.$services.monitor.saveFinalTechnicalReport(payload.grantId, payload.reportId, payload.data)
        .then((data: any) => {
            if (data.Result === 'OK') {
                context.commit('refreshModel', { report: data.Record });
                if(payload.context !== 'submit') {
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Report saved successfully', color: 'success' } as INotification),  { root: true });         
                }
            } else {
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
            }
        });
    },

    getGrantInfo(context: Context, id: number): any {
        if(id) {            
            return this.$services.monitor.getGrantInformation(id, context.state.selectedReport.TechnicalReportId)
            .then((result: any) => {
                let tmp = result.template.reduce((obj: any, tmpl: any) => {
                    obj[tmpl.Key] = tmpl.Value;
                    return obj;
                }, {});
                context.commit('setGrantTemplate', {template : tmp});

                if(result.techReportTemplate)
                    context.commit('setTechnicalReportTemplate', result.techReportTemplate);
                else
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: 'Report Template is not mapped.', color: 'error' } as INotification),  { root: true })
                
                context.commit('setGrant', result);
                return result;
            });
        }
    },

    updateSelectedKey(context: Context, payload: any) {
        context.commit('updateSelectedKey', payload);
    },

    uploadDocument(context: Context, payload: any) {
        context.commit('application/updateOverlay', true, { root: true });
        return this.$services.document.uploadDocument(payload.file, payload.schema, payload.transactionId, payload.language)
        .then((resp) => {
            context.commit('application/updateOverlay', false, { root: true });
            return resp;
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification));
        })
    }
}